import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { ComponentProps } from "react";
import { Dispatch } from "redux";
import React from "react";
import schoolImage from "../../../common/images/school-orange.svg";
import downloadWhiteImage from "../../../common/images/download-white.svg";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { getValidityPeriodMetaItem } from "../../../common/utils/getValidityPeriodMetaItem";
import { handleOnDownloadClick } from "../../../common/utils/handleOnDownloadClick";
import {
    setIsLeftTagOpenIndex,
    setIsRightTagOpenIndex,
} from "../EmployeeInactiveSlice";

type DetailCardMetadataItem = NonNullable<
    ComponentProps<typeof DetailCard>["metadata"]
>[number];

type DetailCardAction = NonNullable<
    ComponentProps<typeof DetailCard>["actions"]
>[number];

interface MetadataProps {
    certificate: CertificateInterface;
    dispatch: Dispatch;
    isLeftTagOpenIndex: number | null;
    isRightTagOpenIndex: number | null;
    leftTagRef: React.RefObject<HTMLDivElement | null>;
    rightTagRef: React.RefObject<HTMLDivElement | null>;
}

export const getEmployeeInactiveCertificateCardMetadata = (
    props: MetadataProps,
): DetailCardMetadataItem[] => {
    const {
        certificate,
        dispatch,
        isLeftTagOpenIndex,
        isRightTagOpenIndex,
        leftTagRef,
        rightTagRef,
    } = props;

    const metadata: DetailCardMetadataItem[] = [
        {
            type: "tags",
            tags: certificate.qualification.function_group.map(
                (tag) => tag.name,
            ),
            variant: "primary",
            isOpen: isLeftTagOpenIndex === certificate.id,
            onToggle: () => dispatch(setIsLeftTagOpenIndex(certificate.id)),
            modalRef: leftTagRef,
        },
        {
            type: "tags",
            tags: certificate.qualification.qualification_standards.map(
                (tag) => tag.tag,
            ),
            variant: "secondary",
            isOpen: isRightTagOpenIndex === certificate.id,
            onToggle: () => dispatch(setIsRightTagOpenIndex(certificate.id)),
            modalRef: rightTagRef,
        },
        getValidityPeriodMetaItem({
            expiresAt: certificate.expires_at,
        }),
    ];

    if (certificate.educator?.name) {
        metadata.push({
            type: "label",
            icon: schoolImage,
            label: certificate.educator.name,
        });
    }

    return metadata;
};

export const getEmployeeInactiveCertificateCardHeaderAction = (
    certificate: CertificateInterface,
): DetailCardAction | undefined => {
    if (!certificate.certificate_file.file_url) {
        return undefined;
    }

    return {
        type: "icon-button",
        icon: downloadWhiteImage,
        backgroundColor: "#E67A01",
        onClick: () => {
            void handleOnDownloadClick(certificate.certificate_file.file_url);
        },
    };
};
